module.exports = __webpack_public_path__ + "static/media/channel.1f0ba6a6.svg";